module.exports = __webpack_public_path__ + "img/6.51adbee2.jpg";